import React, { FC } from "react";

import { Cta } from "../../../buttons/cta";
import { HeaderMenuLinksSection } from "./header-menu-links-section";

export interface HeaderMenuItemTabProps {
  tab: Queries.HeaderMenuItemTabDataFragment;
  isSingleTab?: boolean;
}

export const HeaderMenuItemTab: FC<HeaderMenuItemTabProps> = ({ tab, isSingleTab }) => {
  const { linksSections, ctas, id, tabLabel } = tab;
  return (
    <div className="flex flex-col gap-3" key={id}>
      {isSingleTab && <h4 className="text-xl">{tabLabel}</h4>}
      {!!linksSections?.length && (
        <div className="flex flex-col gap-2">
          {linksSections.map((linksSection, i) =>
            linksSection ? (
              <HeaderMenuLinksSection
                isSingleLinkSection={linksSections.length === 1}
                linksSection={linksSection}
                key={i}
              />
            ) : null
          )}
        </div>
      )}
      {!!ctas?.length && (
        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
          {ctas?.map((cta, i) =>
            cta?.label ? (
              <Cta {...cta} size="sm" key={i} variant={i === 0 ? "neutral" : "light"} />
            ) : null
          )}
        </div>
      )}
    </div>
  );
};
